import type { TemplateLayerRef } from '@/api/types/template'
import type { TemplateListItem } from '@/lib/templates/types/template-list-item'

/**
 * Which layer route a tray template loads from, and the id that route takes. A customer template
 * (`/templates/custom`) is identified by its `customerTemplateId`, a library one by its
 * `templateId`; `TemplateListItem.id` already holds the right one, so only the route differs.
 */
export function resolveTemplateLayerRef(template: TemplateListItem): TemplateLayerRef {
  return {
    source: 'customerTemplateId' in template.raw ? 'custom' : 'library',
    id: template.id,
  }
}
